import { get, post } from '@/utils/request'
import type { LoginPayload, TokenResponse, User } from '@/types'

/** 登录 */
export const login = (payload: LoginPayload) =>
  post<TokenResponse>('/auth/login', payload)

/** 注册 */
export const register = (data: Record<string, unknown>) =>
  post<User>('/auth/register', data)

/** 刷新 token */
export const refreshToken = (token: string) =>
  post<{ access_token: string }>('/auth/refresh', null, { params: { token } })

/** 获取当前用户 */
export const getMe = () => get<User>('/auth/me')
